import isEmpty from 'lodash/isEmpty'
import { type FC, memo, useRef } from 'react'

import useGetNode from '@app/hooks/useGetNode'
import Node from '@app/pages/strategies/components/nodes/components/node'
import SubmapToolbar from '@app/pages/strategies/components/nodes/components/toolbar/submapToolbar'
import { useStrategyMapContext } from '@app/pages/strategies/strategyMapContext'
import SubMapCard from '@app/shared/cards/subMap/subMapCard'
import type { DomainNode } from '@app/types'

const StrategyNode: FC<DomainNode> = (rfNode) => {
  const { id } = rfNode
  const node = useGetNode(id)
  const ref = useRef(null)
  const { mapMode } = useStrategyMapContext()

  const strategy = node?.data // the node's domain object

  if (!strategy || isEmpty(strategy)) {
    return null
  }

  const { strategyId } = node // the currently-viewed strategy, NOT the node's domain object

  return (
    <Node
      topHandle={{ type: 'source' }}
      leftHandle={{ type: 'source' }}
      rightHandle={{ type: 'source' }}
      bottomHandle={{ type: 'source' }}
      nodeRef={ref}
      node={node}
    >
      <SubmapToolbar strategyId={strategyId} node={node} />
      <SubMapCard strategyId={strategyId} strategy={strategy} node={node} mapMode={mapMode} />
    </Node>
  )
}

export default memo(StrategyNode)
